import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button, Popconfirm,
    Pagination, Popover, Tabs,
} from 'antd';

import {asyncGet, actions, asyncGetUserList, asyncGetTaskInfo, delect, asyncGetMonitorList,asyncGetEvs} from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
const TabPane = Tabs.TabPane;
import Edit from './edit.js';
import moment from 'moment';
import {stringToTime} from "../../../utils";
import {Link} from "react-router-dom";



class taskExcuteData extends React.Component {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
        this.props.asyncGetMonitorList();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        if(this.props.uiStatus.onSelectTab == "1"){
            this.props.asyncGet();
        }else{
            this.props.asyncGetEvs();
        }
    };

    edit = (record, type) => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record._id);
      //  this.props.asyncGetTaskInfo(record, type);
    }

    handleDelete = async record => {
        record.deleteFlag = '1';
        this.props.delect(record);
        this.props.asyncGet();
    }
    tabsChange = async (text, record) => {
        console.log(text+'-----'+record);
        await this.props.changeSelectTab(text);
        this.$child.handleSearch();
    }
    handleSearch(input){
        //将子组件对象绑定到父组件的$child属性，这个属性名可以自己随便起
        this.$child = input;
    }
    renderAction = (text, record) => {
        // console.log(expanded, record);
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => {
                    this.edit(record);
                }}>
                    编辑
                </Button>
                <Popconfirm
                    title='确认删除'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.handleDelete(record);
                    }}>
                    <Button type="danger" style={{ marginRight: '5px' }} size="small">
                        删除
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    render() {
        let { list, uiStatus ,pagination,listEv} = this.props;
        let { isLoading } = uiStatus;
        const columnsEv = [
            {
                title: 'eId',
                dataIndex: 'eid',
                key: 'eid',
            },
            {
                title: 'taskid',
                dataIndex: 'taskid',
                key: 'taskid',
            },
            {
                title: '时间',
                dataIndex: 'tm',
                key: 'tm',
            },
            {
                title: '检测公司',
                dataIndex: 'monitoringName',
                key: 'monitoringName',
            },
            {
                title: '响应个数',
                dataIndex: 'exposure_count',
                key: 'exposure_count',
            },
            ];
        const columns = [
            {
                title: 'eId',
                dataIndex: 'eId',
                key: 'eId',
            },
            {
                title: '时间',
                dataIndex: 'tm',
                key: 'tm',
            },
            {
                title: '检测公司',
                dataIndex: 'listTasks',
                key: 'listTasks',
                render: (text, record) => {
                    const columns = [
                        {
                            title: '检测公司',
                            dataIndex: 'monitoringName',
                            key: 'monitoringName',
                        }
                    ];
                    let hashmap = {};
                    text.forEach(
                        item =>{
                            hashmap[item.monitoringName] = item;
                        }
                    );
                    let array = new Array();
                    for(let a in hashmap){
                        array.push(hashmap[a]);
                    }
                    const content = (
                        <Table
                            columns={columns}
                            dataSource={array}
                            pagination={false}
                            scroll={{ y: 500 }}
                        />
                    );
                    return (
                        <Popover
                             content={content}
                             trigger="click">
                             <Button > {text ? array.length : ''}</Button>
                         </Popover>
                    );
                },
            },
            {
                title: '执行个数',
                dataIndex: 'successCount',
                key: 'successCount',
            },
            {
                title: '执行总时长(s)',
                dataIndex: 'executeTime',
                key: 'executeTime',
                render: (text, record) => (
                    (text/1000).toFixed(2)
                )
            },
            {
                title: '平均执行时长(s)',
                dataIndex: 'averageExecuteTime',
                key: 'averageExecuteTime',
                render: (text, record) => (
                    (text/1000).toFixed(2)
                )
            },
            {
              title: '停留时长(s)',
              dataIndex: 'stayTime',
              key: 'stayTime',
              render: (text, record) => (
                  (text/1000).toFixed(2)
                )
            },
            {
                title: '平均停留时长(s)',
                dataIndex: 'averageStayTime',
                key: 'averageStayTime',
                render: (text, record) => (
                    (text/1000).toFixed(2)
                )
            },
            {
                title: '到达个数',
                dataIndex: 'arriveCount',
                key: 'arriveCount',
            },
            {
                title: 'ga/mz(到达数)',
                dataIndex: 'gaMzArriveData',
                key: 'gaMzArriveData',
            },
            {
                title: '到达率',
                dataIndex: 'arriveRatio',
                key: 'arriveRatio',
            },
            {
                title: '互动触发监测个数',
                dataIndex: 'interactiveCount',
                key: 'interactiveCount',
            },
            {
                title: '跳出率',
                dataIndex: 'interactiveRatio',
                key: 'interactiveRatio',
                render: (text, record) => (
                    (1-text).toFixed(2)
                )
            },
            {
                title: '互动成功个数',
                dataIndex: 'interactiveSuccessCount',
                key: 'interactiveSuccessCount',
            },
            {
                title: '互动成功率',
                dataIndex: 'interactiveSuccessRatio',
                key: 'interactiveSuccessRatio',
            },
        ];
        let { totalPage, current, pageSize } = pagination;
        const expandedRowRender = (dataJson, topId) => {
            let record = dataJson.listTasks;
            if (record.length) {
                let cols = [
                    {
                        title: 'taskId',
                        dataIndex: 'taskId',
                        key: 'taskId',
                    },
                    {
                        title: '时间',
                        dataIndex: 'tm',
                        key: 'tm',
                    },
                    {
                        title: '检测公司',
                        dataIndex: 'monitoringName',
                        key: 'monitoringName',
                    },
                    {
                        title: '执行个数',
                        dataIndex: 'successCount',
                        key: 'successCount',
                    },
                    {
                        title: '执行总时长(s)',
                        dataIndex: 'executeTime',
                        key: 'executeTime',
                        render: (text, record) => (
                            (text/1000).toFixed(2)
                        )
                    },
                    {
                        title: '平均执行时长(s)',
                        dataIndex: 'averageExecuteTime',
                        key: 'averageExecuteTime',
                        render: (text, record) => (
                            (text/1000).toFixed(2)
                        )
                    },
                    {
                        title: '停留时长(s)',
                        dataIndex: 'stayTime',
                        key: 'stayTime',
                        render: (text, record) => (
                            (text/1000).toFixed(2)
                        )
                    },
                    {
                        title: '平均停留时长(s)',
                        dataIndex: 'averageStayTime',
                        key: 'averageStayTime',
                        render: (text, record) => (
                            (text/1000).toFixed(2)
                        )
                    },
                    {
                        title: '到达个数',
                        dataIndex: 'arriveCount',
                        key: 'arriveCount',
                    },
                    {
                        title: '到达率',
                        dataIndex: 'arriveRatio',
                        key: 'arriveRatio',
                    },
                    {
                        title: '互动触发监测个数',
                        dataIndex: 'interactiveCount',
                        key: 'interactiveCount',
                    },
                    {
                        title: '跳出率',
                        dataIndex: 'interactiveRatio',
                        key: 'interactiveRatio',
                        render: (text, record) => (
                            (1-text).toFixed(2)
                        )
                    },
                    {
                        title: '互动成功个数',
                        dataIndex: 'interactiveSuccessCount',
                        key: 'interactiveSuccessCount',
                    },
                    {
                        title: '互动成功率',
                        dataIndex: 'interactiveSuccessRatio',
                        key: 'interactiveSuccessRatio',
                    },
                ];
                return (
                    <Table
                        columns={cols}
                        dataSource={record}
                        pagination={false}
                    />
                );
            } else {
                return <span>出错</span>;
            }
        };
        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props}  handleSearch={this.handleSearch.bind(this)} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Tabs defaultActiveKey={this.props.uiStatus.onSelectTab} onChange={this.tabsChange}>
                        <TabPane tab="点击检测" key="1">
                            <Table
                                columns={columns}
                                dataSource={list}
                                expandedRowRender={record => expandedRowRender(record, record.eId)}
                                pagination={false}
                            />
                        </TabPane>
                        <TabPane tab="曝光检测" key="2">
                            <Table
                                columns={columnsEv}
                                dataSource={listEv}
                                pagination={false}
                                defaultExpandAllRows={false}
                            />
                        </TabPane>
                    </Tabs>
                     <Row type="flex" justify="end">
                        <Pagination
                            style={{ padding: '10px 10px' }}
                            size="small"
                            showQuickJumper
                            pageSize={pageSize}
                            current={current}
                            total={totalPage}
                            showTotal={(total, range) =>
                                `共 ${total ? total : '0'} 条记录，每页 ${pageSize} 条，这是第 ${totalPage
                                    ? current + '/' + totalPage
                                    : '1'} 页`}
                            showSizeChanger
                            pageSizeOptions={['10', '15', '20', '40','100','500','1000']}
                            onShowSizeChange={this.handlePaginationChange}
                            onChange={this.handlePaginationChange}
                        />
                    </Row>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.taskExcuteData.list,
    listEv: state.taskExcuteData.listEv,
    pagination: state.taskExcuteData.pagination,
    proxyrepeatinfo: state.taskExcuteData.proxyrepeatinfo,
    uiStatus: state.taskExcuteData.uiStatus,
    agentsGroup: state.taskExcuteData.agentsGroup,
    transferData: state.taskExcuteData.transferData,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    asyncGetEvs: () => dispatch(asyncGetEvs()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeSelectTab: text => dispatch(actions.changeUiStatus({ onSelectTab: text })),
    asyncGetTaskInfo: (record, type) => dispatch(asyncGetTaskInfo(record, type)),
    asyncGetUserList: () => dispatch(asyncGetUserList()),
    changePagination: data => dispatch(actions.changePagination(data)),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    delect: record => dispatch(delect(record)),
    asyncGetMonitorList: () => dispatch(asyncGetMonitorList()),
});
export default connect(mapStateToProps, mapDispatchToProps)(taskExcuteData);






// WEBPACK FOOTER //
// ./pages/monitor/taskExcuteData/index.js